import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RepoView } from '../components/n4/RepoView';
import { api } from '../lib/api';
import { btn } from '../lib/n4';

// A projekt repója teljes szélességben (a projekt-oldal Repo füle ide vezet).
export function ProjectRepo() {
  const { id } = useParams();
  const projectId = Number(id);
  const navigate = useNavigate();
  const [project, setProject] = useState<{ id: number; name: string; dir: string } | null>(null);
  useEffect(() => { api<{ project: { id: number; name: string; dir: string } }>(`/api/projects/${projectId}`).then((r) => setProject(r.project)).catch(() => setProject(null)); }, [projectId]);
  if (!project) return <div className="p-6 text-sm text-neutral-500">betöltés…</div>;
  return (
    <div className="h-full overflow-auto p-4 sm:p-6">
      <div className="mb-3 flex flex-wrap items-center gap-3">
        <button className={btn} onClick={() => navigate(`/projects/${projectId}`)}>← {project.name}</button>
        <div className="text-sm font-semibold text-neutral-100">Repo</div>
        <div className="truncate text-[11px] text-neutral-600">{project.dir}</div>
      </div>
      <RepoView projectId={projectId} projectName={project.name} />
    </div>
  );
}
